import React from "react";

import isIntuit from "Intuit/isIntuit";

import { Popover } from "Cobalt/Popover";
import BodyText from "Common/BodyText";
import Icon from "Common/Icon";
import SIOverlayTrigger from "Common/SIOverlayTrigger";

import type { MedicalPlan } from "Utils/types";

import makeBem from "Utils/makeBem";

const bem = makeBem("PlanRecommendation");
type Props = {
  recommendation: MedicalPlan["recommendation"];
};

const PlanRecommendation = ({ recommendation }: Props) => {
  const labels = recommendation.map((rec, i) => {
    const recommendationPopover = (
      <Popover showBackdrop={false} id={`plan-recommendation-${i}`}>
        <strong>Recommended For:</strong>
        <br />
        <ul>
          {rec.recommendations.map((r, i) => (
            <li className={bem("Guidance")} key={i}>
              {r}
            </li>
          ))}
        </ul>
      </Popover>
    );
    return (
      <SIOverlayTrigger placement="bottom" overlay={recommendationPopover} trackType="compare-recommendation" trackId={rec.label} key={i}>
        <BodyText mt={isIntuit() ? 1 : 2}>
          <Icon icon={rec.icon} flavor="light" flip={rec.icon == "baby-carriage" ? "horizontal" : ""} fixedWidth mr={isIntuit() ? 1 : 2} />
          {rec.label}
        </BodyText>
      </SIOverlayTrigger>
    );
  });
  return <div>{labels}</div>;
};

export default PlanRecommendation;
